"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFE_TYPES = void 0;
exports.MFE_TYPES = {
    core: "core",
    widget: "widget",
    primary: "primary",
    widgetPu: "widgetPu",
    widgetSinistri: "widgetSinistri",
    widgetAreaRiservata: "widgetAreaRiservata",
    widgetSia: "widgetSia",
    widgetRegLogin: "widgetRegLogin",
    widgetTelepedaggio: "widgetTelepedaggio",
    widgetAreaPubblica: "widgetAreaPubblica",
    primaryContainer: "primaryContainer",
    widgetAreaPubblicaBucket: "widgetAreaPubblicaBucket",
};
